import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  BLOG_PAGE,
  EDITOR_PAGE,
  GALLERY_PAGE,
  INDUSTRIES,
  PRICING,
  PRODUCTS_PAGE,
  SCANNER_PAGE,
  SUPPORT_PAGE,
  USER_GUIDE_PAGE,
  WHITE_LABEL_PAGE,
  PERFORMLIVE
} from '../../links';
import DesktopHeaderSubMenu from './desktop-submenu';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    border: 'none',
    outline: 'none'
  },
  item: {
    fontSize: 14,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: 1,
    lineHeight: 1.375,
    color: 'inherit',
    
    '& a': {
      color: 'inherit',
      textDecoration: 'none',
      '&.perform': {
        color: "#FF416E",
        '&:hover': {
          color: "#02BBD3"
        }
      },
    },
    '&:hover': {
      color: theme.palette.primary.main,
      background: 'transparent',
      border: 'none'
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'transparent'
    },
    [theme.breakpoints.up('lg')]: {
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2)
    },
    [theme.breakpoints.up('xl')]: {
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3)
    }
  }
}));

const HeaderMenu = ({ className }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const solutionSubmenu = [
    {
      title: 'headerMenu.Industries',
      href: `/${INDUSTRIES}`
    },
    {
      title: 'headerMenu.Products',
      href: PRODUCTS_PAGE
    },
    {
      title: 'headerMenu.Gallery',
      href: GALLERY_PAGE
    },
    {
      title: 'headerMenu.Editor',
      href: EDITOR_PAGE
    },
    {
      title: 'headerMenu.Scanner',
      href: SCANNER_PAGE
    },
    {
      title: 'headerMenu.WhiteLabel',
      href: WHITE_LABEL_PAGE
    }
  ];

  const supportSubmenu = [
    {
      title: 'headerMenu.Support',
      href: SUPPORT_PAGE
    },
    {
      title: 'headerMenu.UserGuide',
      href: USER_GUIDE_PAGE
    }
  ];

  return (
    <>
      <MenuList className={clsx(classes.root, className)}>
        <MenuItem className={classes.item}>
          <DesktopHeaderSubMenu
            title="headerMenu.Solutions"
            data={solutionSubmenu}
          />
        </MenuItem>
        {/* <MenuItem className={classes.item}>
          <Link to={GALLERY_PAGE}>{t('headerMenu.Gallery')}</Link>
        </MenuItem>
        <MenuItem className={classes.item}>
          <Link to={EDITOR_PAGE}>{t('headerMenu.Editor')}</Link>
        </MenuItem>
        <MenuItem className={classes.item}>
          <Link to={SCANNER_PAGE}>{t('headerMenu.Scanner')}</Link>
        </MenuItem>
        <MenuItem className={classes.item}>
          <Link to={WHITE_LABEL_PAGE}>{t('headerMenu.WhiteLabel')}</Link>
        </MenuItem> */}
        <MenuItem className={classes.item}>
          <a href={PRICING}>{t('headerMenu.Pricing')}</a>
        </MenuItem>
        <MenuItem className={classes.item}>
          <Link to={BLOG_PAGE}>{t('headerMenu.Blog')}</Link>
        </MenuItem>
        <MenuItem className={classes.item}>
          <DesktopHeaderSubMenu
            title="headerMenu.Support"
            data={supportSubmenu}
          />
        </MenuItem>
        <MenuItem className={classes.item}>
          <a href={PERFORMLIVE} className="perform" target="_blank">
            PerformLive
          </a>
        </MenuItem>
      </MenuList>
    </>
  );
};

HeaderMenu.propTypes = {
  className: PropTypes.string
};

HeaderMenu.defaultProps = {
  className: ''
};

export default HeaderMenu;
